import m from "../../geodata/es2015/argentinaHigh";
window.am4geodata_argentinaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/argentinaHigh.js
// module id = null
// module chunks = 